import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";
import { Link } from "@reach/router";

function Nettles(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Ouch! You've been walking through some bushes in your search for
            Plant Folk, and something{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              stings very badly!
            </button>
          </p>

          <p>
            "Hello dear. I am one of the plant folk who has a sting in their
            tale.
          </p>
          <p>I am known as stinging nettle but this is a bit harsh.</p>
          <p>
            It gives out a very negative message. I prefer to be known as a
            nettle - forget the stinging bit. I can be used as a{" "}
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              medicine
            </button>
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              or food,
            </button>
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              or for pest control
            </button>
          </p>
          <p> in the garden."</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            ""Ouch, ouch, I am so sorry I didn't mean to hurt you. You are as
            soft and tender (and rather pathetic) as a human.
          </p>

          <p>I am sorry, I didn't mean to hurt you...</p>

          <p> Place an Incident Marker?</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "The only way we have to win this Tournament, is to tell our
            stories...
          </p>
          <p>
            Maybe our strategy should be creating as many Incident Markers as
            possible! Don't we get 1 point per Marker? Imagine 1000 plants
            raising their voices!
          </p>
          <p>Would you write my story down in an Incident Marker please?</p>
          <p>I'm just better at talking.</p>
          <p>It would be great if you help me clear </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              my stingy reputation!
            </button>
          </p>
          <p>
            For example, some people don't know I can be use to create very
            helpful medicine!"
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>Sometime they make me into Nettle meal time...</p>

          <p>
            I am too tasty for my own good, if you know what I mean my dear!
          </p>

          <p>
            I can be eaten as a single vegetable or as an ingredient in foods.
            My leaves must first be cooked or steamed to destroy the hairs on
            them, though...
          </p>

          <p>Those little hairs contain a number of </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              irritating chemicals."
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>""We really get along with the insect Folk, although this </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              Tournament{" "}
            </button>
          </p>
          <p>will change things, you know?</p>
          <p>Lady birds and lacewings lay their eggs on my leaves.</p>

          <p>The eggs hatch into grubs which eat my leaves.</p>

          <p>
            Please leave a patch of nettles in a corner of your garden. You will{" "}
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              love me for it."
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"Love me, love me, love me do.</p>

          <p>Just use gloves or you will </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              get a rash!"
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Nettles;
